import React, { useState, useContext, useEffect } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { reducer } from "../../../context";
import actionType from "../../../context/actionType";
import { Text, Button } from "../PaymentStyles";
import Footer from "../../assets/components/Footer/Footer";
import Api from "../../../helpers/Api";
import { logResponse } from "../../../helpers/Logger";
import { useTranslation } from "react-i18next";
import { Overlay, Modal, CloseDiv } from "./styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

import "./style.css";

interface Props extends RouteComponentProps {}

const renderOverlay = (onClick?: () => void) => {
  return (
    <Overlay onClick={onClick}>
      <Modal>
        <img
          key={"Wechat"}
          src={"https://www.westkowloon.hk/static/dist/img/qrcode_wk.jpg"}
        />
        <CloseDiv>
          <FontAwesomeIcon icon={faTimes} />
        </CloseDiv>
      </Modal>
    </Overlay>
  );
};

const Complete: React.FunctionComponent<Props> = (props) => {
  const ICONS = [
    {
      title: "Facebook",
      imgUrl: "/donation/assets/icons/Facebook-w.svg",
      herf: "https://www.facebook.com/westkowloon",
    },
    {
      title: "Twitter",
      imgUrl: "/donation/assets/icons/twitter.svg",
      herf: "https://twitter.com/wkcda",
    },
    {
      title: "Weibo",
      imgUrl: "/donation/assets/icons/weibo.svg",
      herf: "http://e.weibo.com/u/3536903827",
    },
    {
      title: "Wechat",
      imgUrl: "/donation/assets/icons/wechat.svg",
      qrCode: "https://www.westkowloon.hk/static/dist/img/qrcode_wk.jpg",
    },
  ];

  const { formReducer, configReducer } = useContext(reducer);
  const [donationObj, setDonationObj] = useState<{ [key: string]: any }>({});
  const [transactionId, setTransactionId] = useState("");
  const [showModal, setShowModal] = useState(false);

  const { t, i18n } = useTranslation();
  const useChinese = i18n.language === "zhTW" || i18n.language === "cn";
  let isSuccess = window.location.href.search("successed") >= 0;

  sessionStorage.removeItem("auth");
  sessionStorage.removeItem("SAVED_FORM_DETAILS");
  const getpayResult = () => {
    var url = new URL(window.location.href);
    var token = url.searchParams.get("token");
    const headers = {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: "" + token,
    };
    fetch(`${Api.path(window.location)}/donate/payResult`, {
      method: "GET",
      headers: headers,
    })
      .then((result) => {
        return result.json();
      })
      .then((resJson) => {
        logResponse(
          configReducer.state.debugMode,
          `donate/payResult: ${!!resJson && resJson.msg}`
        );
        console.log(resJson);
        if (!resJson || !resJson.data) {
          return;
        }
        const { donation, payResult } = resJson.data;
        setDonationObj(donation || {});
        setTransactionId(
          `${payResult.ipgTransactionId || ""}/${payResult.oid || ""}`
        );
      })
      .catch((error) => {
        // TODO: Jack need to add redirect to Asset List here?
        console.warn(error);
      });
  };
  const getNewAuth = () => {
    const headers = {
      "Content-Type": "application/json; charset=utf-8",
    };
    let lng = i18n.language;
    const endpoint = lng === "en" ? "en-US" : lng === "cn" ? "cn" : "zh-HK";
    fetch(
      `${Api.path(window.location)}config/getByPath?path=menu.${endpoint}`,
      {
        method: "GET",
        headers: headers,
      }
    )
      .then(function (res) {
        sessionStorage.removeItem("auth");
        sessionStorage.removeItem("SAVED_FORM_DETAILS");
        sessionStorage.setItem("auth", res.headers.get("authorization"));
        console.log(sessionStorage.getItem("auth"));
        return res.json();
      })
      .then((resJson) => {})
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    // Remove selected project / asset info and donation amount after payment is complete / failed
    sessionStorage.removeItem("DONATION_AMOUNT");
    sessionStorage.removeItem("SELECTED_ASSET");
    sessionStorage.removeItem("SELECTED_PROJECT");

    getpayResult();

    getNewAuth();
    formReducer.dispatch({
      type: actionType.form.SET_SCREEN,
      payload: {
        screen: "completion",
      },
    });
  }, []);
  // useEffect(() => {
  //     const asset = sessionStorage.getItem('SELECTED_ASSET');
  //     const project = sessionStorage.getItem('SELECTED_PROJECT');
  //     const selected = asset ? { selectedAsset: JSON.parse(asset) } : project ? { selectedProject: JSON.parse(project) } : undefined;
  //     if(selected) {
  //         formReducer.dispatch({
  //             type: actionType.form.REFRESH_STAGE,
  //             payload: {
  //                 nextStep: 3,
  //                 ...selected,
  //             },
  //         });
  //     }
  // }, []);

  let name;
  let assetName;
  let price;
  let assetRef;
  let acknowledgeName;
  let successRef;
  let isGeneralProject;
  if (donationObj) {
    const { nameplate, personalInfo, payment, project } = donationObj;
    name = personalInfo
      ? `${
          personalInfo.donorNameInReceipt || personalInfo.firstName
            ? personalInfo.firstName + " " + personalInfo.lastName
            : "-"
        }`
      : "-";
    assetName = !project
      ? "-"
      : project.chineseName
      ? `${project.chineseName}/${project.englishName}`
      : project.projectName;
    price = (payment && `$${payment.amount}`) || "-";
    acknowledgeName =
      (nameplate && nameplate.tributeName) ||
      (personalInfo && personalInfo.AcknowledgementNameENG) ||
      "Anonymous";
    assetRef = (donationObj.project && donationObj.project.assetId) || "-";
    successRef = `${donationObj.projectType == "General" ? "G" : "A"}-${
      donationObj.donationId
    }`;
    isGeneralProject = donationObj.projectType == "General";
  }

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        backgroundColor: "#2c3e50",
        display: "flex",
        flexDirection: "column",
        flex: 1,
        ...(isMobile
          ? {
              padding: 40,
            }
          : {
              paddingTop: 80,
              paddingLeft: 200,
              paddingBottom: 100,
              paddingRight: 200,
              minWidth: 800,
            }),
      }}
    >
      <div
        style={{
          fontSize: 48,
          fontFamily: "Microsoft JhengHei",
          color: "white",
        }}
      >
        {isSuccess ? t("success.title_thankyou") : t("success.title_fail")}
      </div>
      <div
        style={{
          fontSize: "100%",
          fontFamily: "Rambla",
          color: "#2c3e50",
          backgroundColor: "white",
          ...(isMobile
            ? {
                padding: 20,
              }
            : {
                paddingLeft: 50,
                paddingRight: 100,
                paddingTop: 20,
                paddingBottom: 20,
              }),
        }}
      >
        {isSuccess ? (
          <div>
            <Text isChinese={useChinese} style={{ fontSize: "120%" }}>
              {t("success.thankYou")}
            </Text>{" "}
            <br />
            <Text isChinese={useChinese} style={{ fontSize: "120%" }}>
              {t("success.thankYou2")}
            </Text>{" "}
            <br />
            <Text isChinese={useChinese} style={{ fontSize: "120%" }}>
              <span
                dangerouslySetInnerHTML={{
                  __html: t("success.thankYou3", {
                    interpolation: { escapeValue: false },
                  }),
                }}
              />
            </Text>{" "}
            <br />
            <Text isChinese={useChinese} style={{ fontSize: "120%" }}>
              <span
                dangerouslySetInnerHTML={{
                  __html: t("success.thankYou4", {
                    interpolation: { escapeValue: false },
                  }),
                }}
              />
            </Text>{" "}
            <br />
          </div>
        ) : (
          <div>
            <Text isChinese={useChinese} style={{ fontSize: "120%" }}>
              {t("success.fail")}
            </Text>
            <br />
            <Text isChinese={useChinese} style={{ fontSize: "120%" }}>
              {t("success.failLine2")}
            </Text>
            <br />
            <Text isChinese={useChinese} style={{ fontSize: "120%" }}>
              {t("success.failLine3")}
            </Text>
            <br />
            <Text isChinese={useChinese} style={{ fontSize: "120%" }}>
              <span
                dangerouslySetInnerHTML={{
                  __html: t("success.failLine4", {
                    interpolation: { escapeValue: false },
                  }),
                }}
              />
            </Text>
          </div>
        )}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          ...(isMobile
            ? { justifyContent: "center", flexWrap: "wrap" }
            : { justifyContent: "flex-end" }),
          marginTop: 20,
        }}
      >
        <Button
          style={{
            fontFamily: "Microsoft JhengHei",
            ...(isMobile ? { marginTop: "14px" } : {}),
            display: "none",
          }}
          onClick={() => {
            window.location.href = isGeneralProject
              ? t("success.donateAgainURLG")
              : t("success.donateAgainURLA");
          }}
        >
          {t("success.donateAgain")}
        </Button>
        <Button
          style={{
            fontFamily: "Microsoft JhengHei",
            ...(isMobile ? { marginTop: "14px" } : {}),
          }}
          onClick={() => {
            window.location.href = t("success.backWestKowloonURL");
          }}
        >
          {t("success.backWestKowloon")}
        </Button>
      </div>

      {/* <Row>
            <Col>
                <div className="sub-header">Nameplate</div>
                <div className="separator" style={{ marginBottom: 36 }} />
                <div className="nameplate">{`First LASTNAME`}</div>
                <div className="message-container" style={{ marginTop: 24, marginBottom: 24 }}>
                    <div className="message">喜歡粵曲，承傳香港歷史文化</div>
                </div>
                <Row style={{ justifyContent: 'center', display: 'flex', marginBottom: 90 }}>
                    <img className="facebook-icon" src={"/assets/icons/share_facebook.png"} />
                </Row>
                <div className="sub-header">Sponsor Tree Species</div>
                <div className="separator" style={{ marginBottom: 31 }} />
                <Row style={{ margin: 0, padding: 0}}>
                {!!image ?
                    <img style={{
                            width: '220px',
                            height: '147px',
                            objectFit: 'cover',
                        }}
                        src={image}/>
                    :
                    <div className="image-container" />
                }
                <Col>
                    <div className="asset-name">{`${englishName} ${inventoryId}`}</div>
                    <div className="asset-name">{`${venue} ${location}`}</div>
                </Col>
                </Row>
            </Col>
        </Row> */}
      <div
        style={{
          display: "flex",
          ...(isMobile
            ? { justifyContent: "center", flexWrap: "wrap" }
            : { justifyContent: "flex-end" }),
          paddingTop: 20,
        }}
      >
        {ICONS.map((icon) => {
          if (icon.herf) {
            return (
              <a href={icon.herf} target="_blank">
                <img
                  key={icon.title}
                  src={icon.imgUrl}
                  style={{ marginRight: 25.8, width: 24, height: 24 }}
                />
              </a>
            );
          } else {
            return (
              <div
                onClick={() => {
                  setShowModal(true);
                }}
              >
                <img
                  key={icon.title}
                  src={icon.imgUrl}
                  style={{ marginRight: 25.8, width: 24, height: 24 }}
                />
              </div>
            );
          }
        })}
      </div>
      {showModal &&
        renderOverlay(() => {
          setShowModal(false);
        })}
    </div>
  );
};

export default withRouter(Complete);
